// extracted by mini-css-extract-plugin
export var content = "_nt-1";
export var fullScreen = "_nt-0";